<div class="popup-placeholder noselect" (click)="$event.stopPropagation()">
  <div class="header">
    <h3>
      Meu Perfil<span *ngIf="validarMudancas" title="Alterações pendentes"
        >*</span
      >
    </h3>
  </div>
  <div class="body">
    <div class="busy-indicator" *ngIf="this.salvando || this.carregando">
      <mat-spinner [mode]="'indeterminate'"> </mat-spinner>
      <span *ngIf="carregando">Carregando informações...</span>
      <span *ngIf="salvando">Salvando alterações...</span>
    </div>

    <span *ngIf="model">
      <mat-card style="margin-bottom: 12px">
        <app-form-identificacao
          (onsaved)="childFormSaved($event)"
          (onsaving)="childFormSaving()"
          (confirmarAlteracoes)="setValidarMudancas($event)"
        >
        </app-form-identificacao>
      </mat-card>

      <!-- <mat-card style="margin-bottom: 12px;" *ngIf="model && !model.trial">
        <app-form-dados-pessoais [dadosServidor]="model" (onsaved)="childFormSaved($event)"
          (onsaving)="childFormSaving()" (confirmarAlteracoes)="setValidarMudancas($event)  "></app-form-dados-pessoais>
      </mat-card> -->

      <mat-accordion>
        <app-form-pagamento
          *ngIf="model && !model.trial"
          [dadosServidor]="model"
          (onsaved)="childFormSaved($event)"
          (onsaving)="childFormSaving()"
          (confirmarAlteracoes)="setValidarMudancas($event)"
        >
        </app-form-pagamento>
        <app-form-alterar-senha
          (onsaved)="childFormSaved($event)"
          (onsaving)="childFormSaving()"
          (confirmarAlteracoes)="setValidarMudancas($event)"
        >
        </app-form-alterar-senha>
        <app-form-indicacoes
          *ngIf="model && !model.trial"
          [dadosServidor]="model"
          (onsaved)="childFormSaved($event, true)"
          (onsaving)="childFormSaving(true)"
        ></app-form-indicacoes>
        <app-form-cancelamento
          [dadosServidor]="model"
          (onsaved)="childFormSaved($event, true)"
          (onsaving)="childFormSaving(true)"
        ></app-form-cancelamento>
      </mat-accordion>
    </span>
  </div>
</div>
